module.exports = __webpack_public_path__ + "img/csv-doc-icon.2c437f75.svg";